import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  navigationLink: {
    display: 'inline-block',
    textDecoration: 'none',
    marginTop: 10,
    color: theme.palette.link.main,
  },
});

const NavigationLink = ({
  classes, to, children, external,
}) => (external
  ? (
    <a href={to} className={classes.navigationLink}>
      {children}
    </a>
  )
  : (
    <Link className={classes.navigationLink} to={to}>
      {children}
    </Link>
  ));

NavigationLink.propTypes = {
  classes: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  external: PropTypes.bool,
};

NavigationLink.defaultProps = {
  external: false,
};

export default withStyles(styles)(NavigationLink);
